module.exports = __webpack_public_path__ + "static/img/22.2fa89a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/22.png
// module id = DHDT
// module chunks = 0